import {
  CREDITOR_ID_CHARACTER_REGEX,
  SEPA_CHARACTER_REGEX,
  UMLAUTS_REGEX,
} from "@/scripts/Constants";

const hasSepaCondition = (value: string) => typeof value === 'string' && SEPA_CHARACTER_REGEX.test(value);

const hasValidLengthOnSepaCondition = (value: string, maxLength: number) => {
  return typeof value === 'string'
    && value.replace(UMLAUTS_REGEX, 'aa').length <= maxLength;
}

const hasSepaCreditorIdCondition = (value: string) => typeof value === 'string' && CREDITOR_ID_CHARACTER_REGEX.test(value);

export {
  hasSepaCondition,
  hasValidLengthOnSepaCondition,
  hasSepaCreditorIdCondition
}
